import React from 'react';
import CountUp from 'react-countup';
import Chart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const DashboardSalesChart = ({ metrics, loading, isShow }) => {
  const series = [
    {
      name: `Propostas`,
      data: metrics?.sales?.chart?.data,
    },
  ];

  const options = {
    chart: {
      type: 'area',
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
      width: 1,
    },
    xaxis: {
      categories: metrics?.sales?.chart?.labels,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    colors: ['#405189'],
    yaxis: {
      labels: {
        formatter: function (value) {
          return value;
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    fill: {
      opacity: 0.9,
    },
    tooltip: {
      x: {
        show: true,
        formatter: (seriesName) => {
          // const day = metrics?.sales?.chart?.labels[seriesName - 1];
          return `Dia: ${seriesName}`;
        },
      },
      fixed: {
        enabled: false,
        position: 'topRight',
      },
    },
  };

  const SalesChartView = () => {
    return (
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">
            Propostas de {metrics?.actualMonth}
          </h4>
        </CardHeader>
        <CardHeader className="p-0 border-0 bg-soft-light">
          <Row className="g-0 text-center">
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="854">
                    <CountUp
                      start={0}
                      end={metrics && metrics.sales.resume.today}
                      duration={1}
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Hoje</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="1278">
                    <CountUp
                      start={0}
                      end={metrics && metrics.sales.resume.week}
                      duration={1}
                      separator="."
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Esta semana</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="3">
                    <CountUp
                      start={0}
                      end={metrics && metrics.sales.resume.month}
                      duration={1}
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Este mês</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-1 border-end-0">
                <h5 className="mb-1">
                  <span className="counter-value" data-target="3">
                    <CountUp
                      start={0}
                      end={metrics && metrics.sales.resume.year}
                      duration={1}
                    />
                  </span>
                </h5>
                <p className="text-muted mb-0">Este ano</p>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-0">
          <Chart
            type="bar"
            height={400}
            series={series}
            options={options}
            className="apex-charts"
          />
        </CardBody>
      </Card>
    );
  };

  return loading ? (
    <Col xs={12} md={6} lg={6}>
      <Card>
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={515} />
            </div>
          </Row>
        </SkeletonTheme>
      </Card>
    </Col>
  ) : isShow ? (
    <Col xs={12} md={6} lg={6}>
      <SalesChartView />
    </Col>
  ) : null;
};
